import type { SyncStateItem } from 'src/modules/syncing';

import { type SyncingAction, SYNCING_UPDATED } from './index';

export const syncingUpdated = (state: SyncStateItem): SyncingAction => ({
  type: SYNCING_UPDATED,
  payload: state,
});
